"use strict";

function _typeof(obj) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (obj) { return typeof obj; } : function (obj) { return obj && "function" == typeof Symbol && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }, _typeof(obj); }
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _react = _interopRequireWildcard(require("react"));
var _propTypes = _interopRequireDefault(require("prop-types"));
var _TableHeadCell = _interopRequireDefault(require("./TableHeadCell.style"));
var _Icon = _interopRequireDefault(require("../icon/Icon"));
var _excluded = ["accessor", "children", "sortable", "sortDirection", "clickAction"];
function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }
function _getRequireWildcardCache(nodeInterop) { if (typeof WeakMap !== "function") return null; var cacheBabelInterop = new WeakMap(); var cacheNodeInterop = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(nodeInterop) { return nodeInterop ? cacheNodeInterop : cacheBabelInterop; })(nodeInterop); }
function _interopRequireWildcard(obj, nodeInterop) { if (!nodeInterop && obj && obj.__esModule) { return obj; } if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") { return { "default": obj }; } var cache = _getRequireWildcardCache(nodeInterop); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (key !== "default" && Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj["default"] = obj; if (cache) { cache.set(obj, newObj); } return newObj; }
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
var sortDirections = ['asc', 'desc', 'default'];
var TableHeadCell = function TableHeadCell(_ref) {
  var accessor = _ref.accessor,
    children = _ref.children,
    sortable = _ref.sortable,
    sortDirection = _ref.sortDirection,
    clickAction = _ref.clickAction,
    otherProps = _objectWithoutProperties(_ref, _excluded);
  var nextDirectionMapping = {};
  for (var i = 0; i < sortDirections.length - 1; i += 1) {
    nextDirectionMapping[sortDirections[i]] = sortDirections[i + 1];
  }
  nextDirectionMapping[sortDirections[sortDirections.length - 1]] = sortDirections[0];
  var handleClick = function handleClick() {
    clickAction(accessor, nextDirectionMapping[sortDirection]);
  };
  var clickProperties = typeof clickAction === 'function' && sortable ? {
    onClick: handleClick,
    onKeyDown: handleClick,
    role: 'link',
    tabIndex: '0'
  } : {};
  return /*#__PURE__*/_react["default"].createElement(_TableHeadCell["default"], _extends({
    sortable: sortable
  }, clickProperties, otherProps), children, sortable && /*#__PURE__*/_react["default"].createElement("span", {
    className: "sort-icons"
  }, sortDirection === 'asc' && /*#__PURE__*/_react["default"].createElement(_Icon["default"], {
    icon: "ion-android-arrow-dropup"
  }), sortDirection === 'desc' && /*#__PURE__*/_react["default"].createElement(_Icon["default"], {
    icon: "ion-android-arrow-dropdown"
  }), sortDirection === 'default' && /*#__PURE__*/_react["default"].createElement(_react.Fragment, null, /*#__PURE__*/_react["default"].createElement(_Icon["default"], {
    icon: "ion-android-arrow-dropup"
  }), /*#__PURE__*/_react["default"].createElement(_Icon["default"], {
    icon: "ion-android-arrow-dropdown"
  }))));
};
TableHeadCell.propTypes = {
  /** The alignment of the table text */
  align: _propTypes["default"].oneOf(['right', 'left', 'center']),
  /**
   * The api name for this field (used for sorting)
   * */
  accessor: _propTypes["default"].oneOfType([_propTypes["default"].shape({}), _propTypes["default"].string]),
  /**
   * The content of the table cell, normally a node or a string.
   * */
  children: _propTypes["default"].oneOfType([_propTypes["default"].node, _propTypes["default"].string]),
  /**
   * Callback fired when the column is clicked (Usually used for sorting)
   *
   * @param {string} accessor The api field name for which the sort is done.
   * @param {string} direction The direction for the sorting (asc, desc)
   *
   * */
  clickAction: _propTypes["default"].func,
  /**
   * Flag to indicate wheather the column is sortable.
   * */
  sortable: _propTypes["default"].bool,
  /**
   * The sorting direction of the column in case sortable is true.
   * */
  sortDirection: _propTypes["default"].oneOf(sortDirections)
};
TableHeadCell.defaultProps = {
  align: 'left',
  accessor: '',
  children: '',
  clickAction: undefined,
  sortable: false,
  sortDirection: 'default'
};
TableHeadCell.__docgenInfo = {
  "description": "",
  "methods": [],
  "displayName": "TableHeadCell",
  "props": {
    "align": {
      "defaultValue": {
        "value": "'left'",
        "computed": false
      },
      "description": "The alignment of the table text",
      "type": {
        "name": "enum",
        "value": [{
          "value": "'right'",
          "computed": false
        }, {
          "value": "'left'",
          "computed": false
        }, {
          "value": "'center'",
          "computed": false
        }]
      },
      "required": false
    },
    "accessor": {
      "defaultValue": {
        "value": "''",
        "computed": false
      },
      "description": "The api name for this field (used for sorting)",
      "type": {
        "name": "union",
        "value": [{
          "name": "shape",
          "value": {}
        }, {
          "name": "string"
        }]
      },
      "required": false
    },
    "children": {
      "defaultValue": {
        "value": "''",
        "computed": false
      },
      "description": "The content of the table cell, normally a node or a string.",
      "type": {
        "name": "union",
        "value": [{
          "name": "node"
        }, {
          "name": "string"
        }]
      },
      "required": false
    },
    "clickAction": {
      "defaultValue": {
        "value": "undefined",
        "computed": true
      },
      "description": "Callback fired when the column is clicked (Usually used for sorting)\r\n\r\n@param {string} accessor The api field name for which the sort is done.\r\n@param {string} direction The direction for the sorting (asc, desc)",
      "type": {
        "name": "func"
      },
      "required": false
    },
    "sortable": {
      "defaultValue": {
        "value": "false",
        "computed": false
      },
      "description": "Flag to indicate wheather the column is sortable.",
      "type": {
        "name": "bool"
      },
      "required": false
    },
    "sortDirection": {
      "defaultValue": {
        "value": "'default'",
        "computed": false
      },
      "description": "The sorting direction of the column in case sortable is true.",
      "type": {
        "name": "enum",
        "value": [{
          "value": "'asc'",
          "computed": false
        }, {
          "value": "'desc'",
          "computed": false
        }, {
          "value": "'default'",
          "computed": false
        }]
      },
      "required": false
    }
  }
};
var _default = TableHeadCell;
exports["default"] = _default;